import React from "react";
import themeLarge from "../ThemeLarge";
import { FaRegCalendarAlt } from "react-icons/fa";

class BlogTile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobileView: window.innerWidth <= 1100,
    };
  }

  componentDidMount() {
    window.addEventListener("resize", this.updateWindowSize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowSize);
  }

  updateWindowSize = () => {
    this.setState({ isMobileView: window.innerWidth <= 1100 });
  };

  render() {
    const { blog } = this.props;
    const { isMobileView } = this.state;

    return (
      <div
        className="row"
        style={{
          borderWidth: "1px",
          borderColor: themeLarge.colors.text,
          borderStyle: "groove",
          borderRadius: "15px",
          padding: "15px",
          marginRight: isMobileView ? undefined : "5px",
          marginLeft: isMobileView ? undefined : "5px",
          fontFamily: "Kumbh Sans",
          boxShadow: themeLarge.shadows.little,
          background: themeLarge.colors.secondary,
        }}
      >
        {/* Text Content */}
        <div
          className={
            blog.coverPhoto
              ? "col-md-8 d-flex flex-column justify-content-between"
              : "col-md-12 d-flex flex-column justify-content-between"
          }
          style={{ minHeight: "100%" }}
        >
          <div>
            <p
              style={{
                fontSize: themeLarge.fontSize.h3,
                color: themeLarge.colors.text,
                fontWeight: "600",
              }}
            >
              {blog.title}
            </p>

            <p
              style={{
                fontSize: isMobileView? themeLarge.fontSize.small: themeLarge.fontSize.body,
                display: "-webkit-box",
                WebkitLineClamp: isMobileView? 2 : 3,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }}
            >
              {blog.excerpt}
            </p>
          </div>

          <p
            style={{
              fontSize: themeLarge.fontSize.small,
              display: "flex",
              alignItems: "center",
              gap: "5px",
              marginTop: "auto",
            }}
          >
            <FaRegCalendarAlt />
            {blog.createdAt
              ? new Date(blog.createdAt.seconds * 1000).toLocaleDateString("en-US", {
                  month: "short",
                  day: "2-digit",
                  year: "numeric",
                })
              : "Unknown Date"}
          </p>
        </div>

        {/* Cover Image (if exists) */}
        {blog.coverPhoto && (
          <div
            className="col-md-4"
            style={{
              aspectRatio: "16 / 9",
              overflow: "hidden",
              borderRadius: "8px",
              marginBottom: "12px",
              height: "200px",
            }}
          >
            <img
              className="img-fluid rounded shadow-sm"
              src={blog.coverPhoto}
              alt="Blog Cover"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                display: "block",
              }}
            />
          </div>
        )}
      </div>
    );
  }
}

export default BlogTile;
